import { useMutation } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { API_CLINIC_REVIEW_TIME } from 'services/dataService/resources';

interface Body {
  guid: string;
  reviewTimeSeconds: number;
  updateChildrenReviewTime: boolean;
}

export const useClinicReviewTimeModalSave = () => {
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: saveClinicReviewTime,
    onSuccess: () => {
      notificationController.success({
        message: t('messages.reviewTimeUpdated'),
      });
    },
    onError: (error) => {
      const message =
        error instanceof Error
          ? error.message
          : t('messages.reviewTimeUpdatedError');
      notificationController.error({
        message,
      });
    },
  });

  return {
    save: mutateAsync,
    isLoading,
  };
};

const saveClinicReviewTime = async (body: Body) => {
  const { error } = await dataService.updateOnly(API_CLINIC_REVIEW_TIME, body);

  if (error) {
    throw new Error(error);
  }
};
